import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="w-full bg-foreground-950 text-background-200">
      <div className="w-full px-6 md:px-10 py-16 md:py-20">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-10 mb-16">
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
                Categorias
              </h4>
              <div className="w-8 h-px bg-background-400/30 mb-4"></div>
              <ul className="space-y-2.5">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.slug}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-300 hover:text-background-100 transition-colors"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
                Guias SEO
              </h4>
              <div className="w-8 h-px bg-background-400/30 mb-4"></div>
              <ul className="space-y-2.5">
                <li><a href="/artigo/cssbuy-spreadsheet-guia-completo" className="text-sm text-background-300 hover:text-background-100 transition-colors">Guia Completo</a></li>
                <li><a href="/artigo/como-usar-cssbuy-spreadsheet" className="text-sm text-background-300 hover:text-background-100 transition-colors">Como Usar</a></li>
                <li><a href="/artigo/comparacao-cssbuy-pandabuy-superbuy" className="text-sm text-background-300 hover:text-background-100 transition-colors">Comparação</a></li>
                <li><a href="/artigo/seguranca-cssbuy-spreadsheet" className="text-sm text-background-300 hover:text-background-100 transition-colors">Segurança</a></li>
                <li><a href="/artigo/frete-china-brasil" className="text-sm text-background-300 hover:text-background-100 transition-colors">Frete</a></li>
                <li><a href="/artigo/erros-comuns-cssbuy" className="text-sm text-background-300 hover:text-background-100 transition-colors">Erros Comuns</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
                Mais Conteúdo
              </h4>
              <div className="w-8 h-px bg-background-400/30 mb-4"></div>
              <ul className="space-y-2.5">
                <li><a href="/artigo/cssbuy-spreadsheet-atualizado-2026" className="text-sm text-background-300 hover:text-background-100 transition-colors">Atualizado 2026</a></li>
                <li><a href="/artigo/cssbuy-vs-taobao-weidian" className="text-sm text-background-300 hover:text-background-100 transition-colors">CSSBuy vs Taobao</a></li>
                <li><a href="/artigo/guia-comprar-china-brasil" className="text-sm text-background-300 hover:text-background-100 transition-colors">Comprar China→BR</a></li>
                <li><a href="/artigo/melhores-agentes-compra-2026" className="text-sm text-background-300 hover:text-background-100 transition-colors">Melhores Agentes</a></li>
                <li><a href="/artigo/streetwear-cssbuy-spreadsheet" className="text-sm text-background-300 hover:text-background-100 transition-colors">Streetwear</a></li>
                <li><a href="/artigo/sneakers-cssbuy-spreadsheet" className="text-sm text-background-300 hover:text-background-100 transition-colors">Sneakers</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
                Útil
              </h4>
              <div className="w-8 h-px bg-background-400/30 mb-4"></div>
              <ul className="space-y-2.5">
                <li><a href="/artigo/evitar-taxa-importacao" className="text-sm text-background-300 hover:text-background-100 transition-colors">Evitar Taxas</a></li>
                <li><a href="/artigo/tabela-cssbuy-pronta" className="text-sm text-background-300 hover:text-background-100 transition-colors">Tabela Pronta</a></li>
                <li><a href="/" className="text-sm text-background-300 hover:text-background-100 transition-colors">Home</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
                Contato
              </h4>
              <div className="w-8 h-px bg-background-400/30 mb-4"></div>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="text-sm text-background-300 hover:text-background-100 transition-colors"
              >
                kaspreadsheet.com
              </a>
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-start md:items-center justify-between pt-8 border-t border-background-400/20">
            <div>
              <div className="text-4xl md:text-5xl font-heading font-bold text-background-100 leading-none">
                CSSBuy
              </div>
              <div className="text-4xl md:text-5xl font-heading font-light italic text-background-400 leading-none mt-1">
                Spreadsheet
              </div>
              <div className="w-10 h-px bg-background-500/40 mt-4 mb-2"></div>
              <p className="text-xs text-background-500 max-w-xs leading-relaxed">
                Guia completo para comprar da China com segurança e organização.
              </p>
            </div>

            <div className="mt-8 md:mt-0 text-right">
              <p className="text-xs text-background-500">
                &copy; {new Date().getFullYear()} CSSBuy Spreadsheet.
                <br />
                Este site contém conteúdo informativo e links de afiliado.
                <br />
                Não garantimos preços, entregas ou taxas alfandegárias.
              </p>
              <div className="flex items-center gap-4 mt-4 justify-end">
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-8 h-8 flex items-center justify-center rounded-full border border-background-400/30 text-background-400 hover:text-background-100 hover:border-background-200 transition-all"
                  aria-label="Website principal"
                >
                  <i className="ri-global-line text-sm"></i>
                </a>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-8 h-8 flex items-center justify-center rounded-full border border-background-400/30 text-background-400 hover:text-background-100 hover:border-background-200 transition-all"
                  aria-label="Twitter"
                >
                  <i className="ri-twitter-x-line text-sm"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}